import styled, {css} from "styled-components"

interface Image {
  selectedBrand: boolean
  initialOpacityState: boolean
}

export const Container = styled.div`
  ${({theme}) => css`
    display: grid;
    margin-top: ${theme.spacing.four};
    ${theme.mediaQueries.minWidthMedia.tablet`
      grid-template-columns: 2fr 1fr;
    `}
  `}
`

export const LeftColumn = styled.div`
  ${({theme}) => css`
    gap: ${theme.spacing.two};
    display: flex;
    flex-direction: column;
    background-color: ${theme.colors.success};
    padding: ${theme.spacing.oneAndHalf};
    border-radius: ${theme.border.radius.medium} 0px 0px ${theme.border.radius.medium};
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: ${theme.spacing.three};
    `}
  `}
`

export const Img = styled.img<Image>`
  ${({selectedBrand, initialOpacityState, theme}) => css`
    opacity: ${initialOpacityState ? 1 : selectedBrand ? 1 : 0.3};
    height: 28px;
    border-radius: ${theme.border.radius.large};
    border: ${selectedBrand ? `3px solid ${theme.colors.tertiary.y_200}` : "3px solid transparent"};
    cursor: pointer;
  `}
`

export const RightColumn = styled.div`
  ${({theme}) => css`
    background-color: ${theme.colors.secondary2};
    padding: ${theme.spacing.oneAndHalf};
    border-radius: 0px ${theme.border.radius.medium} ${theme.border.radius.medium} 0px;
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: ${theme.spacing.three};
    `}
  `}
`

export const ProTip = styled.div`
  display: none;
  ${({theme}) => theme.mediaQueries.minWidthMedia.phone`
    display: block;
    span {
      line-height: 18px;
    }
  `}
`
